<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Upload File
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center m-2">
        <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
          <div>{{ generalErrorMessage }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-7 mt-3">
          <b-form-group :label-cols="4"
                        label="Description"
                        breakpoint="md"
                        label-class="text-right"
                        :state="stateForField('description')"
                        :invalid-feedback="errorForField('description')">
            <b-form-input id="description-input"
                          v-model="fileDescription"
                          type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4"
                        :state="stateForField('uploadFile')"
                        :invalid-feedback="errorForField('uploadFile')">
            <b-form-file
                accept="image/jpeg, image/png, application/pdf"
                browse-text="Select File"
                v-model="uploadFile"
                placeholder="Choose a file..."
                drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange m-1 wide-button float-right" @click.prevent="submitFile()">
        <i v-if="isUploading" class="fa fa-spinner fa-spin"></i> Upload File
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'

  export default {
    name: 'PayeeFileUploadModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      paymentDistributionId: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        fileDescription: '',
        isUploading: false,
        uploadFile: null,
        errors: []
      }
    },
    watch: {
      visible (newValue) {
        if (newValue) {
          this.clearData()
          this.clearAllErrors()
        }
      }
    },
    methods: {
      clearData () {
        this.fileDescription = ''
      },
      validate () {
        this.clearAllErrors()

        if (!this.fileDescription) {
          this.addErrorForField('description', 'You must enter a description')
        }
        if (!this.uploadFile) {
          this.addErrorForField('uploadFile', 'You must select a file')
        }
        return !this.hasErrors()
      },
      submitFile () {
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()

        if (this.isUploading === true) {
          return
        }
        if (!this.uploadFile || this.uploadFile.length === 0) {
          return
        }
        const multipartForm = new FormData()
        multipartForm.append('file', this.uploadFile)
        this.isUploading = true
        api.post('/Dashboard/PaymentDistribution/' + this.paymentDistributionId + '/UploadDocument?fileDescription=' + this.fileDescription, multipartForm, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
          this.isUploading = false
          this.$emit('updated', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            if (!this.generalErrorMessage) {
              if (this.errorsMixin.errors && this.errorsMixin.errors['']) {
                const file = this.errorsMixin.errors[''][0]
                this.addErrorForField('exception', file)
              }
            }
            this.$log.error('Error attempting to upload file: ' + error.message, error)
          }
        }).then(() => {
          this.isUploading = false
        })
      },
      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
</style>
